import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useAnchor } from 'shared/hooks/utils';
import { select_selected_devices_tree_filters } from 'console/redux/selectors';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { SearchField } from 'console/shared/components/fields/search';
import { FiltersMenu } from './filters-menu';
import { Badge, Box } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { useHasPaidTariff } from 'console/shared/hooks/helpers';
const sx = { mr: 1, cursor: 'pointer' };
export const DeviceSearchField = memo(function DeviceSearchField(props) {
    const { search, setSearch } = props;
    const onClickClearSearch = useCallback(() => setSearch(''), [setSearch]);
    const available_to_user = useHasPaidTariff();
    const selected_filters = useAppSelector(select_selected_devices_tree_filters) ?? [];
    const [filtersMenuAnchor, openFiltersMenu, closeFiltersMenu] = useAnchor();
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [_jsx(SearchField, { value: search, onChange: setSearch, onClear: onClickClearSearch, placeholder: "\u041F\u043E\u0438\u0441\u043A \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432...", size: "small", sx: {
                    padding: 1,
                    borderRadius: 30,
                }, children: available_to_user ? (_jsx(Badge, { badgeContent: selected_filters.length, color: "error", onClick: openFiltersMenu, invisible: selected_filters.length === 0, sx: sx, children: _jsx(FilterList, {}) })) : null }), _jsx(FiltersMenu, { onMenuClose: closeFiltersMenu, anchor: filtersMenuAnchor, selected_filters: selected_filters })] }));
});
